module.exports = __webpack_public_path__ + "media/svg/logo-white-d297178e.svg";